module.exports = __webpack_public_path__ + "static/media/СЗФО_2007.9e971ca3.png";